<div class="flex pl-1 gap-2 justify-start">
    <!-- Currency -->
    @if (modelSig().currency) {
        <p-badge
            [ngClass]="getOpenItemStatusStyle()"
            [class.cursor-pointer]="modelSig().balanceStatus === 'COMPLETED'"
            [pTooltip]="statusText"
            [value]="getCurrencyValue()"
            (click)="openBalanceForCompletedOpenItems()"
        ></p-badge>
    }
    @if (modelSig().accountingDescription) {
        <div>
            @if (modelSig().accountingDescription === 'PAYMENT') {
                <i
                    class="fa-solid fa-file-invoice-dollar !text-center text-muted-color text-lg align-middle"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            } @else if (modelSig().accountingDescription === 'COMPLETED_PAYMENT') {
                <i
                    class="fa-solid fa-file-invoice-dollar !text-center text-success text-lg align-middle"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            } @else if (modelSig().accountingType === 'OPENITEM') {
                <i
                    class="fa-solid fa-file-invoice !text-center text-lg align-middle"
                    [ngClass]="getOpenItemStyle()"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            } @else if (modelSig().accountingDescription === 'CASH_DISCOUNTABLE') {
                <i
                    class="fa-solid fa-receipt !text-center text-info text-lg align-middle"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            } @else if (modelSig().accountingDescription === 'UNDER_PAYED') {
                <i
                    class="fa-solid fa-receipt !text-center text-orange-300 text-lg align-middle"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            } @else if (modelSig().accountingDescription === 'OVER_PAYED') {
                <i
                    class="fa-solid fa-receipt !text-center text-blue-300 text-lg align-middle"
                    [pTooltip]="modelSig().tooltip"
                ></i>
            }
        </div>
    }
</div>
